/**
 * External dependencies
 */
import React from "react";
import ContentLoader from "react-content-loader";

const CardLoader = ({ speed = 2, ...rest }) => {
	return (
		<ContentLoader
			speed={speed}
			width={400}
			height={430}
			viewBox="0 0 400 430"
			backgroundColor="#f3f3f3"
			foregroundColor="#ecebeb"
			style={{ width: "100%" }}
			preserveAspectRatio="none"
			{...rest}
		>
			<rect x="0" y="0" rx="0" ry="0" width="400" height="225" />
			<rect x="0" y="0" rx="0" ry="0" width="1" height="430" />
			<rect x="399" y="0" rx="0" ry="0" width="1" height="430" />
			<rect x="0" y="429" rx="0" ry="0" width="400" height="1" />
			<rect x="20" y="250" rx="0" ry="0" width="235" height="25" />
			<rect x="20" y="340" rx="0" ry="0" width="90" height="15" />
			<rect x="20" y="400" rx="0" ry="0" width="45" height="10" />
			<rect x="75" y="400" rx="0" ry="0" width="45" height="10" />
			<rect x="130" y="400" rx="0" ry="0" width="45" height="10" />
		</ContentLoader>
	);
};

export default CardLoader;
